import { userType, applicationList } from "../utils/postgraphile";

export const userPermission = (user) => {
    const auth = {
        superAdmin: false,
        siteAdmin: false,
        campaign: false,
        dermarise: false,
        pro: false,
        readOnly: false,
        lmbc: false,
        admin: false,
        allerganPro: false,
        basicLogin: false,
        userManager: false,
    };

    if (user.userType === userType.SUPER_ADMIN) {
        auth.admin = true;
        auth.superAdmin = true;
    }
    if (user.userType === userType.BASIC_LOGIN_ADMIN) {
        auth.admin = true;
        auth.basicLoginAdmin = true;
    }
    if (user.userType === userType.READ_ONLY) {
        auth.admin = true;
        auth.readOnly = true;
    }

    if (user.userType === userType.USER_MANAGER) {
        auth.admin = true;
        auth.userManager = true;
    }

    if (user.userType === userType.APP_ADMIN) {
        auth.admin = true;
        const appNamePro = applicationList.ABBVIEPRO;
        const appNameLmbc = applicationList.ABBVIELMBC;
        const appNameAllerganPro = applicationList.ALLERGANPRO;
        const appNameBasicLogin = applicationList.BASIC_LOGIN;
        const appNameArray = user.adminPermissions || [];
        const appProBoolean = appNameArray.includes(appNamePro);
        const appLmbcBoolean = appNameArray.includes(appNameLmbc);
        const appAllerganProBoolean = appNameArray.includes(appNameAllerganPro);
        const appBasicLoginBoolean = appNameArray.includes(appNameBasicLogin);

        if (appProBoolean) {
            auth.superAdmin = false;
            auth.siteAdmin = true;
            auth.pro = true;
        }
        if (appLmbcBoolean) {
            auth.superAdmin = false;
            auth.siteAdmin = true;
            auth.lmbc = true;
        }
        if (appAllerganProBoolean) {
            auth.superAdmin = false;
            auth.siteAdmin = true;
            auth.allerganPro = true;
        }
        if (appBasicLoginBoolean) {
            auth.superAdmin = false;
            auth.siteAdmin = true;
            auth.basicLogin = true;
        }
    }
    return auth;
};
